<template>
  <div class="site-section bg-light">
    <!-- <banner /> -->
    <div class="full-cover">
      <div class="head-wrap">
        <div class="head-left">
          <img src="@/assets/productimg/zsk.png" alt="" style="width: 120px;" />
          <div class="h-btitle">
            知识创新与协作平台
          </div>
          <div class="h-stitle" style="margin: 10px 0 35px;">
            成员知识沉淀与经验交互的高效利器，有效调动企业知识软财富，提高生产创造力。
          </div>
        </div>
        <img src="@/assets/productimg/banner.png" alt="" class="head-right" />
      </div>
    </div>
    <div class="four-wrap">
      <div class="four-item">
        <img src="@/assets/productimg/f1.png" alt="" class="four-icon" />
        <div class="four-title">随时创作</div>
        <div class="four-desc">
          移动端/PC端随时查看文件、在线编辑，满足外出拜访、出差、在家办公等多种场景需求，随时记录思想火花。
        </div>
      </div>
      <div class="four-item">
        <img src="@/assets/productimg/f2.png" alt="" class="four-icon" />
        <div class="four-title">丰富模板</div>
        <div class="four-desc">
          产品研发、人事招聘、IT运营、市场营销、项目管理、团队博客等企业常用文档模板皆免费使用，助您全面开启知识创作。
        </div>
      </div>
      <div class="four-item">
        <img src="@/assets/productimg/f3.png" alt="" class="four-icon" />
        <div class="four-title">结构化工具</div>
        <div class="four-desc">
          通过树形文档目录、高级搜索、关注标签等结构化工具，直观地展现页面层次结构，轻松整理和查找页面。
        </div>
      </div>

      <div class="four-item">
        <img src="@/assets/productimg/f4.png" alt="" class="four-icon" />
        <div class="four-title">权限管理</div>
        <div class="four-desc">
          可见权限、编辑权限、共享权限等随意切换，在保证隐私内容的基础上自由访问数据信息。
        </div>
      </div>
    </div>
    <div class="app-wrap" style="padding-bottom: 0px;">
      <div class="txt-pic">
        <div class="txt-wrap left-txt" style="text-align: left;">
          <div class="small-title">效率 · 交互</div>
          <div class="txt-btitle">多人协作，为员工赋能</div>
          <div class="txt-stitle" style="width: 75%;text-align: justify;">
            当您和同事知识互补时，开启协作功能，知识记录实时同步，边写边审阅，激发想法，高效创作。
          </div>
          <!-- <span class="wk-btn baidu_qiao" style="margin-top: 20px;"
            >立即咨询</span
          > -->
        </div>
        <div class="pic-wrap">
          <img src="@/assets/productimg/p1.png" alt="" class="pic-el" />
        </div>
      </div>
    </div>
    <div class="app-wrap">
      <div class="txt-pic">
        <div class="pic-wrap">
          <img src="@/assets/productimg/p2.png" alt="" class="pic-el" />
        </div>
        <div
          class="txt-wrap left-txt"
          style="text-align: left;padding-left: 12.5%;"
        >
          <div class="small-title">灵动 · 活跃</div>
          <div class="txt-btitle">
            评论互动，思想碰撞
          </div>
          <div class="txt-stitle" style="text-align: justify;">
            点赞、评论与回复功能，记录团队成员的建议与反馈，使您的思想不再局限，文档每一步改进皆有据可依，全流程记录知识创作过程。
          </div>
          <!-- <span class="wk-btn baidu_qiao" style="margin-top: 20px;"
            >立即咨询</span
          > -->
        </div>
      </div>
    </div>
    <div class="app-wrap" style="padding-bottom: 0px;">
      <div class="txt-pic">
        <div class="txt-wrap left-txt" style="text-align: left;">
          <div class="small-title">学习 · 传承</div>
          <div class="txt-btitle">全员共享，新员工快速成长</div>
          <div class="txt-stitle" style="width: 75%;text-align: justify;">
            公司介绍、制度、手册等公开文档全员共享，支撑新人、一线员工快速成长，实现关键岗位有效传承。
          </div>
          <!-- <span class="wk-btn baidu_qiao" style="margin-top: 20px;"
            >立即咨询</span
          > -->
        </div>
        <div class="pic-wrap">
          <img src="@/assets/productimg/p3.png" alt="" class="pic-el" />
        </div>
      </div>
    </div>
    <div class="app-wrap">
      <div class="txt-pic">
        <div class="pic-wrap">
          <img src="@/assets/productimg/p4.png" alt="" class="pic-el" />
        </div>
        <div
          class="txt-wrap left-txt"
          style="text-align: left;padding-left: 12.5%;"
        >
          <div class="small-title">便捷 · 畅通</div>
          <div class="txt-btitle">
            一级兼容，知识畅行
          </div>
          <div class="txt-stitle" style="text-align: justify;">
            不管是什么格式：Word、PPT、Excel；不管是什么版本：1997、2013、2020等等，睿泽知识库多维度兼容，让您随时查看知识文档，提供给您一级的管理体验。
          </div>
          <!-- <span class="wk-btn baidu_qiao" style="margin-top: 20px;"
            >立即咨询</span
          > -->
        </div>
      </div>
    </div>
    <div class="other">
      <div class="btitle" style="margin-bottom: 60px;">您可能还希望了解</div>
      <div class="indpro container">
        <div class="contain clearFix">
          <!-- <div class="indpro-bar clearFix">
            <div class="indtit">
              <h4>产品中心</h4>
              <p>丰富、安全、稳定的云产品及服务</p>
            </div>
          </div> -->
          <div class="indpro-item clearFix ontrue">
            <div class="indpro-list clearFix">
              <ul>
                <li v-for="(item, index) in arr" :key="index">
                  <div class="indpro-wd">
                    <i class="indpro-wd-img"><img :src="item.img" alt=""/></i>

                    <h4>{{ item.title }}</h4>
                    <p>{{ item.desc }}</p>
                  </div>
                  <div class="indpro-link" v-if="item.link">
                    <router-link :to="item.link">查看详情</router-link>
                    <!-- <a :href="item.link"><span>查看详情</span></a> -->
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="app-wrap">
      <div class="txt-pic">
        <div class="txt-wrap left-txt" style="text-align: left;">
          <div class="txt-btitle">支持移动办公</div>
          <div class="txt-stitle">
            睿泽移动端助力客户管理CRM、人资管理HRM、财务管理FS，<br />
            并全面支持Andorid、IOS系统，无缝接入企业微信与钉钉，<br />
            实现多系统数据实时互通，随时随地多设备办公。
          </div>
        </div>
        <div class="pic-wrap">
          <img src="@/assets/productimg/app.png" alt="" class="pic-el" />
        </div>
      </div>
    </div>
    <div class="app-wrap">
      <div class="txt-pic">
        <div class="pic-wrap">
          <img src="@/assets/productimg/dingding.png" alt="" class="pic-el" />
        </div>
        <div class="txt-wrap left-txt" style="text-align: right;">
          <div class="txt-btitle">
            与企业微信、钉钉实施互通<br />
            私域流量尽在掌控
          </div>
          <div class="txt-stitle">
            客户引流、同步聊天记录、客户sop、会话审计、群运营、<br />
            智能话术等功能，打造基于社交生态的动态客户管理系统。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/views/products/components/Banner";
import cp1 from "@/assets/cp_1.png";
import cp2 from "@/assets/cp_2.png";
import cp3 from "@/assets/cp_3.png";
import cp4 from "@/assets/cp_4.png";
import cp5 from "@/assets/cp_5.png";
import cp6 from "@/assets/cp_6.png";
export default {
  name: "Products",
  components: { Banner },
  data() {
    return {
      header: "产品中心",
      leader: "业务、财务一体化高效管理",
      arr: [
        {
          img:
            "https://wuzhong-assets.oss-accelerate.aliyuncs.com/assets/zd/qu6mi9b9jo00/资产保护.png",
          title: "智慧资管",
          desc: "专业的云端高效资产管理系统",
          link: "/assetManagement"
        },
        {
          img:
            "https://wuzhong-assets.oss-accelerate.aliyuncs.com/assets/zd/qu6mi9b9jo00/财务统计.png",
          title: "智慧财务",
          desc: "助力企业、政府构建智能财务云平台",
          link: "/finance"
        },
        {
          img:
            "https://wuzhong-assets.oss-accelerate.aliyuncs.com/assets/zd/qu6mi9b9jo00/电表.png",
          title: "智慧电表",
          desc: "远程操控  实时计量自动化管理电表",
          link: "/electricity"
        },
        {
          img:
            "https://wuzhong-assets.oss-accelerate.aliyuncs.com/assets/zd/qu6mi9b9jo00/阳光.png",
          title: "阳光村务",
          desc: "村级决策、管理、监督平台",
          link: "/sunshine"
        },
        {
          img:
            "https://wuzhong-assets.oss-accelerate.aliyuncs.com/assets/zd/qu6mi9b9jo00/可视化.png",
          title: "云大数据可视化平台",
          desc: "大数据BI全方位监测中心",
          link: "/bigdata"
        },
        {
          img:
            "https://wuzhong-assets.oss-accelerate.aliyuncs.com/assets/zd/qu6mi9b9jo00/星星.png",
          title: "金蝶云·星辰",
          desc: "新营销、新财税、新模式 小微企业成分服务平台",
          link: "kingdeestar"
        },
        {
          img:
            "https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/10095745sxiz.png",
          title: "金蝶·精斗云",
          desc: "助力企业打造智能化、移动化、一体化的经营管理体系",
          link: "jdy"
        },
        {
          img:
            "https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/10095826mkk5.png",
          title: "金蝶云·星瀚",
          desc: "助力大企业实现转型升级和创新发展",
          link: "cosmic"
        },
        {
          img:
            "https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/10095844imu5.png",
          title: "金蝶云·星空",
          desc: "助力高成长型企业重构数字战斗力",
          link: "galaxy"
        },
        {
          img: require('@/assets/cp_6.png'),
          title: "企业电商",
          desc:
            "快速实现了企业的网络化，数字化管理，最大限度的适应网络时代市场需求的变化",
          link: false
        },
        {
          img: require('@/assets/cp_5.png'),
          title: "办公集采",
          desc:
            "协助企业从供应市场获取产品或服务作为企业资源， 以保证企业生产及经营活动正常开展的一项企业经营活动",
          link: false
        },
        {
          img: require('@/assets/cp_4.png'),
          title: "钉钉",
          desc:
            "助力企业的组织数字化和业务数字化，实现企业管理“人、财、物、事、产、供、销、存”的全链路数字化",
          link: false
        },
        {
          img: require('@/assets/cp_2.png'),
          title: "泛微",
          desc:
            "进一步完善现有协同管理软件中身份认证、电子签名、电子印章和电子合同的集成应用",
          link: false
        },
        {
          img: require('@/assets/cp_3.png'),
          title: "致远",
          desc: "持续助力企业及政府提高协同运营管理效率，实现数智化转型升级",
          link: false
        },
        {
          img: require('@/assets/cp_1.png'),
          title: "企业微信",
          desc:
            "丰富的OA应用，和连接微信生态的能力，可帮助企业连接内部、连接生态伙伴、连接消费者",
          link: false
        }
      ],
      arr4: [
        { content: "合同管理" },
        { content: "资产管理" },
        { content: "资产立项" }
      ],
      arr5: [
        {
          title: "合同管理",
          content:
            "自定义合同信息，合同提交与终止，合同所属机构修改，合同导入与导出",
          url: require("@/assets/productimg/pro1.png")
        },
        {
          title: "资产管理",
          content: "信息提交与审核,资产类型变更,自定义资产信息",
          url: require("@/assets/productimg/pro2.png")
        },
        {
          title: "资产立项",
          content: "新建资产立项,立项审核查看,完善交易需求",
          url: require("@/assets/productimg/pro3.png")
        }
      ],
      partI: false,
      partII: false,
      partIII: false,
      partIV: false,
      style1: "",
      style2: "",
      style3: "",
      style4: "",
      itemShow: "first",
      imgarray: [
        {
          title: "img1",
          url: "https://picsum.photos/1024/480/?image=52",
          text:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo deleniti dicta fuga minima qui excepturi consequatur pariatur nisi voluptatem consectetur enim, voluptate eos, obcaecati, iusto repellendus tenetur doloremque sequi libero."
        },
        {
          title: "img2",
          url: "https://picsum.photos/1024/480/?image=54",
          text:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo deleniti dicta fuga minima qui excepturi consequatur pariatur nisi voluptatem consectetur enim, voluptate eos, obcaecati, iusto repellendus tenetur doloremque sequi libero."
        },
        {
          title: "img3",
          url: "https://picsum.photos/1024/480/?image=58",
          text:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo deleniti dicta fuga minima qui excepturi consequatur pariatur nisi voluptatem consectetur enim, voluptate eos, obcaecati, iusto repellendus tenetur doloremque sequi libero."
        },
        {
          title: "img4",
          url: "https://picsum.photos/1024/480/?image=55",
          text:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo deleniti dicta fuga minima qui excepturi consequatur pariatur nisi voluptatem consectetur enim, voluptate eos, obcaecati, iusto repellendus tenetur doloremque sequi libero."
        }
      ]
    };
  },
  mounted() {},
  beforeDestroy() {},
  methods: {}
};
</script>

<style scoped lang="scss">
/* banner */
.full-cover {
  background-color: #fafbfc;
  padding-top: 50px;
  padding-bottom: 50px;
  width: 100%;
  .head-wrap {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .head-left {
      text-align: left;
      .h-btitle {
        color: #172b4d;
        font-size: 42px;
        line-height: 60px;
      }
      .h-stitle {
        line-height: 30px;
        font-size: 20px;
        color: #42526e;
      }
    }
    .head-right {
      width: 50%;
    }
  }
}

.four-wrap {
  width: 1200px;
  padding-top: 90px;
  padding-bottom: 60px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .four-item {
    width: 20%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    .four-icon {
      width: 60px;
      margin-bottom: 20px;
    }
    .four-title {
      color: #172b4d;
      font-size: 18px;
      margin-bottom: 10px;
      font-weight: bold;
    }
    .four-desc {
      color: #42526e;
      font-size: 14px;
      line-height: 22px;
      text-align: justify;
    }
  }
}

.app-wrap {
  background-color: #fff;
  padding-top: 60px;
  padding-bottom: 60px;
  .txt-pic {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .txt-pic .txt-wrap {
    width: 50%;
  }
  .left-txt {
    justify-content: center;
  }
  .txt-pic .pic-wrap {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .small-title {
    color: #6b778c;
    font-size: 24px;
    margin-bottom: 10px;
  }
  .txt-wrap .txt-btitle {
    color: #172b4d;
    font-size: 36px;
    margin-bottom: 20px;
  }
  .txt-wrap .txt-stitle {
    color: #42526e;
    font-size: 16px;
    line-height: 24px;
  }
  .wk-btn {
    padding: 15px 30px;
    background-color: #0252cc;
    border-radius: 3px;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
    display: inline-block;
  }
  .txt-pic .pic-wrap .pic-el {
    width: 100%;
    display: inline-block;
    /* background: #FFFFFF; */
    /* box-shadow: 0px 2px 12px 0px #d7dbdf; */
    border-radius: 3px;
    /* text-align: center; */
  }
}
.other {
  padding-top: 128px;
  padding-bottom: 128px;
  background: #f8f8f8;
  .btitle {
    font-size: 36px;
    line-height: 50px;
    color: #172b4d;
    text-align: center;
  }
}

/* 其他产品 */
.indpro {
  width: 100%;
  padding: 80px 0 50px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background: #f8f8f8;
}
.indpro-bar {
  width: 100%;
}

.indtit {
  width: auto;
  text-align: center;
  margin-bottom: 50px;
}

.indpro-menu {
  float: right;
  font-size: 0;
  padding-top: 40px;
}

.clearFix:after {
  clear: both;
}

.indtit h4 {
  font-size: 32px;
  color: #061828;
  text-align: center;
}
.indtit p {
  font-size: 16px;
  color: #505362;
  line-height: 24px;
  text-align: center;
  margin-top: 14px;
}
.indpro-menu {
  float: right;
  font-size: 0;
  padding-top: 40px;
}
.indpro-menu-link,
.indpro-menu-more {
  display: inline-block;
  vertical-align: middle;
  user-select: none;
  margin: 30px auto;
}
.indpro-menu-link li {
  display: inline-block;
  margin: 0 20px;
  position: relative;
  font-size: 14px;
  color: #555;
  cursor: pointer;
  transition: all 0.4s ease;
}
.indpro-menu-link li:after {
  content: "";
  width: 0;
  right: 0;
  height: 2px;
  background: #2386ee;
  transition: all 0.4s ease;
  position: absolute;
  bottom: -3px;
}
.indpro-menu-link li.ontrue,
.indpro-menu-link li:hover {
  color: #2386ee;
}
.indpro-menu-link li.ontrue:after {
  width: 100%;
  right: auto;
  left: 0;
}
.indpro-menu-link li:hover:after {
  width: 100%;
  right: auto;
  left: 0;
}

.indpro-menu-more {
  width: 120px;
  height: 36px;
  margin-left: 20px;
  line-height: 34px;
  border-radius: 5px;
  border: 2px solid #2386ee;
  font-size: 14px;
  text-align: center;
  color: #2386ee;
  position: relative;
  transition: all 0.4s ease;
}
.indpro-menu-more span {
  position: relative;
  z-index: 2;
}
.indpro-menu-more span:after {
  /* content: "\f105"; */
  font-family: "FontAwesome";
  margin-left: 6px;
  font-size: 22px;
  display: inline-block;
  transform: translateY(2px);
}
.indpro-menu-more:after {
  content: "";
  width: 0;
  right: 0;
  height: 100%;
  background: linear-gradient(135deg, #0068dd, #00aeee);
  position: absolute;
  transition: all 0.4s ease;
}
.indpro-menu-more:hover {
  color: #fff;
}
.indpro-menu-more:hover:after {
  width: 100%;
  left: 0;
}
.indpro-box {
  width: 100%;
  margin-top: 30px;
}
.indpro-item {
  width: 100%;
  /* display: none; */
}
.clearFix:before,
.clearFix:after {
  display: table;
  content: "";
}
.indpro-video {
  width: 300px;
  float: left;
  padding: 86px 0 0 36px;
  height: 465px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-image: url(https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202009/161019034t97.jpg);
  text-align: left;
}

.indpro-video-title h6 {
  font-size: 26px;
  color: #222;
  font-weight: 700;
}

.indpro-video-title p {
  font-size: 18px;
  color: #444;
  font-weight: 300;
  margin-top: 12px;
}
.indpro-wd {
  width: 100%;
  text-align: center;
  transition: all 0.4s ease;
}
.indpro-wd i {
  display: block;
  height: 62px;
  line-height: 62px;
  overflow: hidden;
  transition: all 0.2s ease;
}
.indpro-wd i img {
  height: 62px;
}
.indpro-wd h4 {
  font-size: 24px;
  color: #222;
  margin: 10px 0 16px;
}
.indpro-wd p {
  font-size: 14px;
  color: #777;
  line-height: 22px;
  max-width: 300px;
  margin: 0 auto;
  min-height: 44px;
}
.indpro-link {
  width: 100%;
  position: absolute;
  bottom: -54px;
  left: 0;
  font-size: 0;
  z-index: 4;
  transition: all 0.4s ease;
}
.indpro-link a {
  display: inline-block;
  vertical-align: top;
  height: 54px;
  line-height: 54px;
  text-align: center;
  width: 50%;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.4s ease;
}
.indpro-link a:first-child {
  border: 1px solid #2386ee;
  color: #2386ee;
  background: #fff;
}
.indpro-link a:last-child {
  background: linear-gradient(135deg, #0068dd, #00aeee);
  color: #fff;
}
.indpro-link a:hover span {
  font-size: 16px;
  transition: all 0.4s ease;
}

.indpro-link a:last-child span {
  transition: all 0.4s ease;
  color: whitesmoke;
}

.indpro-link a:first-child span {
  transition: all 0.4s ease;
}

.indpro-list {
  /* width: calc(100% - 300px);
  float: right; */
}
.indpro-list ul {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;
}
.indpro-list li {
  border: 1px solid #eee;
  border-top: 2px solid #007bff;
  width: 31%;
  margin: 0 2% 40px 0;
  margin-right: 3%;
  margin-bottom: 40px;
  height: 232.5px;
  background: #fff;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  transition: all 0.4s ease;
}
.indpro-list li:nth-child(3n) {
  margin-right: 0;
}
.indpro-list li:before {
  content: "";
  width: 1px;
  height: 100%;
  position: absolute;
  background: #dae0e5;
  top: 0;
  right: 0;
}
.indpro-list li:after {
  content: "";
  width: 100%;
  height: 1px;
  position: absolute;
  background: #dae0e5;
  bottom: 0;
  left: 0;
}
.indpro-list li:hover .indpro-link {
  bottom: 0;
}
.indpro-list li:hover .indpro-wd i {
  opacity: 0;
}
.indpro-list li:hover .indpro-wd {
  transform: translateY(-66px);
}
.indpro-list li:hover {
  box-shadow: 0 4px 16px 0px rgba(0, 0, 0, 0.12);
  z-index: 2;
}
</style>>



// WEBPACK FOOTER //
// src/views/products/Products.vue